import { render, staticRenderFns } from "./media-patterns.vue?vue&type=template&id=2c266058&scoped=true&"
import script from "./media-patterns.vue?vue&type=script&lang=js&"
export * from "./media-patterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c266058",
  null
  
)

export default component.exports